import { render, staticRenderFns } from "./KerkenList.vue?vue&type=template&id=c95d7906&scoped=true"
import script from "./KerkenList.vue?vue&type=script&lang=js"
export * from "./KerkenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95d7906",
  null
  
)

export default component.exports